var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightTears = function SvgRightTears(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 496,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187 504c-44.194 0-80-34.106-80-76.216a72.947 72.947 0 0 1 6.88-30.956L188.125 224l71.1 170.995c4.987 9.966 7.775 21.094 7.775 32.789C267 469.868 231.169 504 187 504Z",
    fill: "url(#rightTears_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.5-29C168.439-29 217 17.774 217 75.525c0 15.083-3.33 29.459-9.331 42.454L106.974 355l-96.43-234.507C3.782 106.825 0 91.564 0 75.525 0 17.809 48.596-29 108.5-29Z",
    fill: "url(#rightTears_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rightTears_svg__a",
    x1: 271.797,
    y1: 208.651,
    x2: 21.999,
    y2: 332.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#106BF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053589"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rightTears_svg__b",
    x1: 107.722,
    y1: 355.358,
    x2: 286.424,
    y2: 105.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#106BF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053589"
  })))));
};
export default SvgRightTears;